import React, { Component } from 'react';
import Footer from '../../Components/Footer';
import Header from '../../Components/Header';
import ModalLogin from '../../Containers/Modal_Login';
import ModalRegister from '../../Containers/Modal_Register';
import ModalSuccess from '../../Containers/ModalSuccess';
import Partner from '../../Containers/Partner';

export default class PartnerPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className='profile-page'>
        <Header />
        <main>
          <div style={{ marginBottom: 120 }}>
            <Partner />
          </div>
          <ModalLogin />
          <ModalRegister />
          <ModalSuccess />
        </main>
        <Footer />
      </div>
    );
  }
}
